import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { BreadCrumbs, BreadcrumbData } from '@ifixit/carpenter-breadcrumbs/Breadcrumbs';

const NavBreadcrumbs = ({ breadcrumbs }: { breadcrumbs: BreadcrumbData[] }) => {
   if (!breadcrumbs) {
      return null;
   }

   return (
      <div className="flex h-full w-full pl-4">
         <BreadCrumbs breadCrumbs={breadcrumbs} />
      </div>
   );
};

// BreadCrumbs (@ifixit/carpenter-breadcrumbs) still uses Chakra (useBreakpointValue),
// so it needs a ChakraProvider — keep initializeChakraComponent until that package
// is migrated. This file itself no longer imports the Chakra component library.
initializeChakraComponent('NavBreadcrumbs', NavBreadcrumbs);
